import { LvfIdentityCredentialType } from "../../enum/identity/lvf-identity-credential-type";
import { LvfLoginIdentifierType } from "../../enum/identity/lvf-login-identifier-type";
import { LvfAppPlatform } from "../../enum/application/lvf-app-platform";

export interface ILoginRequest {
  Identifier: string;
  IdentifierType?: LvfLoginIdentifierType;
  Email?: string;
  Password: string;
  TenantCode?: string;
  RememberMe?: boolean;
  CredentialType?: LvfIdentityCredentialType;
  RequestedPlatform?: LvfAppPlatform;
}

export class LoginRequest implements ILoginRequest {
  Identifier: string = '';
  IdentifierType: LvfLoginIdentifierType = LvfLoginIdentifierType.UNKNOWN;
  Email?: string;
  Password: string = '';
  TenantCode?: string;
  RememberMe: boolean = false;
  CredentialType: LvfIdentityCredentialType = LvfIdentityCredentialType.INTERNAL_PASSWORD;
  RequestedPlatform: LvfAppPlatform = LvfAppPlatform.WEB;

  constructor(info?: Partial<ILoginRequest>) {
    if (info) {
      this.Identifier = info.Identifier ?? info.Email ?? '';
      this.IdentifierType = info.IdentifierType ?? LvfLoginIdentifierType.UNKNOWN;
      this.Email = info.Email;
      this.Password = info.Password ?? '';
      this.TenantCode = info.TenantCode;
      this.RememberMe = info.RememberMe ?? false;
      this.CredentialType = info.CredentialType ?? LvfIdentityCredentialType.INTERNAL_PASSWORD;
      this.RequestedPlatform = info.RequestedPlatform ?? LvfAppPlatform.WEB;
    }
  }
}
